<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M685.6 591.1H512c-19 0-34.4-15.4-34.4-34.4s15.4-34.4 34.4-34.4h173.6c19 0 34.4 15.4 34.4 34.4s-15.4 34.4-34.4 34.4zm0 0" />
        <path d="M512 591.1c-9.1 0-17.9-3.6-24.3-10.1-6.4-6.4-10.1-15.2-10.1-24.3V338.4c0-19 15.4-34.4 34.4-34.4s34.4 15.4 34.4 34.4v218.3c0 9.1-3.6 17.9-10.1 24.3-6.4 6.4-15.2 10.1-24.3 10.1zm0 0" />
        <path d="M512 952c-188-.1-350-132.6-387.3-316.9C87.4 450.8 185 265.8 358.1 192.5c200.8-83.5 431.4 10.9 516 211.2 84.6 200.3-8.4 431.4-208.3 517.2-48.6 20.6-100.9 31.2-153.8 31.1zm0-721.9c-155.8 0-289.9 110-320.3 262.8-30.4 152.9 51.4 305.9 195.3 365.5 144 59.6 310 9.3 396.5-120.3 86.6-129.5 69.6-302.2-40.6-412.3-61.1-61.5-144.3-95.9-230.9-95.7zm405.6 86c-11.7 0-22.5-5.9-28.9-15.7-45.8-70.7-110.5-127.1-186.8-162.9-17.2-8.1-24.6-28.5-16.5-45.7 8.1-17.2 28.5-24.6 45.7-16.5C819 116.5 893.6 181.5 946.4 263c6.9 10.6 7.4 24.1 1.4 35.1-6 11.1-17.6 18-30.2 18zm-811.2 0c11.7 0 22.5-5.9 28.9-15.7 45.8-70.7 110.5-127.1 186.8-162.9 17.2-8.1 24.6-28.5 16.5-45.7-8.1-17.2-28.5-24.6-45.7-16.5-88 41.2-162.6 106.2-215.4 187.7-6.9 10.6-7.4 24-1.4 35.1 6.1 11.1 17.7 18 30.3 18zm0 0" />
      </g>
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
